var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',[_c('main',[_c('Spinner',{attrs:{"color":_vm.config.COLOR_PRIMARY}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }